// src/components/SignInForm.tsx
import React, { FC, ChangeEvent, FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import CustomInput from './subComponents/CustomInput';
import Spinner from '@/components/Spinner';
import { Icons } from '@/icons';
const { Email, Lock, EyeClose, EyeOpen } = Icons;

interface SignInFormProps {
  email: string;
  password: string;
  onEmailChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  isSubmitting?: boolean;
  passwordError?: boolean;
  passwordErrorMessage?: string;
}

const SignInForm: FC<SignInFormProps> = ({
  email,
  password,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  isSubmitting = false,
  passwordError = false,
  passwordErrorMessage,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <form
      onSubmit={onSubmit}
      className='w-full flex flex-col items-center'
      noValidate
    >
      <CustomInput
        id='email'
        label='Email'
        Icon={Email}
        type='email'
        placeholder='Enter email here'
        value={email}
        onChange={onEmailChange}
      />

      <CustomInput
        id='password'
        label='Password'
        Icon={Lock}
        type={showPassword ? 'text' : 'password'}
        placeholder='Enter password here'
        value={password}
        onChange={onPasswordChange}
        RightIcon={showPassword ? EyeOpen : EyeClose}
        onRightIconClick={() => setShowPassword((v) => !v)}
        error={passwordError}
        errorMessage={passwordErrorMessage}
      />

      <button
        type='submit'
        disabled={isSubmitting}
        className={`w-full py-2 rounded-full mt-4 transition flex items-center justify-center gap-2
          ${isSubmitting ? 'bg-pink-400 cursor-not-allowed' : 'bg-[#FF0050] hover:bg-pink-600'}
        `}
      >
        {isSubmitting && <Spinner />}
        <span
          className='text-white'
        >
          Sign In
        </span>
      </button>

      <div className='w-full flex justify-end mt-2 mb-6'>
        <Link
          to='/forgot-password'
          className='text-xs sm:text-sm md:text-base text-[#14D8CE] hover:underline'
        >
          Forgot Password?
        </Link>
      </div>
    </form>
  );
};

export default SignInForm;
